export default __webpack_public_path__ + "static/media/redux.cb6a8e4f.png";